import { render, staticRenderFns } from "./smartCanteenScreen.vue?vue&type=template&id=a6f6ac96&scoped=true"
import script from "./smartCanteenScreen.vue?vue&type=script&lang=js"
export * from "./smartCanteenScreen.vue?vue&type=script&lang=js"
import style0 from "./smartCanteenScreen.vue?vue&type=style&index=0&id=a6f6ac96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f6ac96",
  null
  
)

export default component.exports